<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AuthorizationQr',
  computed: {
    ...mapGetters({
      authorizationQr: 'getAuthorizationQr'
    })
  },
  methods: {
    hostUrl() {
      return window.location.host
    }
  }
}
</script>

<template lang="pug">
.authorization-qr.mb-5(v-if="authorizationQr")
  .authorization-qr__text
    .mr-2 {{ $t('remoteAuthQrInfo1') }}
    div {{ $t('remoteAuthQrInfo2') }}
  qr-code(:text="authorizationQr" :size="300")
</template>

<style lang="scss" scoped>
.authorization-qr {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  .authorization-qr__text {
    margin-bottom: 2.5rem;
    font-size: 1.6rem;

    @media (max-width: 991.98px) {
      font-size: 1.4rem;
    }
  }
}
</style>
